import {
  DynamicZoneComponentDTO,
  StrapiDynamicZoneComponentDTO,
} from "@lib/strapi/dtos/core/dynamicZoneComponent.dto";
import { parseStrapiContent } from "@lib/strapi/content";

export interface StrapiMenuSectionDTO extends StrapiDynamicZoneComponentDTO {
  menu: "legal" | "clinical";
  heading: string;
  sticky: boolean;
  hideOnMobile: boolean;
}

export class MenuSectionDTO extends DynamicZoneComponentDTO {
  constructor() {
    super();
  }

  menu: "legal" | "clinical";
  heading: string;
  sticky: boolean;
  hideOnMobile: boolean;
}
